import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import type { DepositPayload } from '../types/Cashier';
import { DepositStatus } from '../types/status';

import { convertAmountByRate, isZeroExponentCurrency } from './cashier';
import {
  TXTCLI_Account_Verification,
  TXTCLI_LetXs_get_you_verified,
  TXTWCL_Bank_Transfer,
  TXTWCL_Deposit_Unavailable,
  TXTWCL_Deposit_result,
  TXTWCL_Processing_Transaction,
  TXTWCL_SorryX_we_canXt_process_your_d_ELL,
  TXTWCL_SorryX_your_transaction_is_del_ELL,
  TXTWCL_YouXve_deposited_N0X,
  TXTWCL_You_canXt_deposit_with_your_ac_ELL,
  TXTWCL_Your_deposit_has_been_declined_1,
  TXTWCL_Your_payment_is_taking_a_littl_ELL,
  TXTWCL_Your_transaction_is_being_proc_ELL,
  TXTWCL_Your_transaction_was_canceled
} from './title.messages.json';

export const getTitle = (
  status: DepositStatus,
  deposit: DepositPayload,
  isBankTransfer: boolean
): JSX.Element => {
  const { amount, rate, balanceCurrency } = deposit || {};

  switch (status) {
    case DepositStatus.COMPLETED:
      return isBankTransfer ? (
        <Translation {...TXTWCL_Bank_Transfer} />
      ) : (
        <Translation
          {...TXTWCL_YouXve_deposited_N0X}
          values={{
            0: (
              <CurrencyAmount
                value={Number(convertAmountByRate(amount, rate, balanceCurrency, false))}
                isZeroExponentCurrency={isZeroExponentCurrency(balanceCurrency)}
                currency={balanceCurrency}
                dollarValue
              />
            )
          }}
        />
      );
    case DepositStatus.AUTHENTICATION_REQUIRED:
      return <Translation {...TXTCLI_Account_Verification} />;
    case DepositStatus.ERRORS:
    case DepositStatus.REJECTED_CARD_BLOCKED:
      return <Translation {...TXTWCL_Deposit_Unavailable} />;
    default:
      return <Translation {...TXTWCL_Deposit_result} />;
  }
};

export const getSubtitle = (
  status: DepositStatus,
  isPayconiqTimeout = false
): JSX.Element | null => {
  switch (status) {
    case DepositStatus.REJECTED:
    case DepositStatus.GOOGLE_PAY_FAILED:
    case DepositStatus.GOOGLE_PAY_CANCELED:
      return <Translation {...TXTWCL_Your_deposit_has_been_declined_1} />;
    case DepositStatus.ERRORS:
    case DepositStatus.REJECTED_CARD_BLOCKED:
      return <Translation {...TXTWCL_You_canXt_deposit_with_your_ac_ELL} />;
    case DepositStatus.TIMEOUT:
      return isPayconiqTimeout ? (
        <Translation {...TXTWCL_Your_transaction_was_canceled} />
      ) : (
        <Translation {...TXTWCL_SorryX_your_transaction_is_del_ELL} />
      );
    case DepositStatus.PRECASHING_TIMEOUT:
    case DepositStatus.GOOGLE_PAY_SESSION_TIMEOUT:
      return <Translation {...TXTWCL_SorryX_your_transaction_is_del_ELL} />;
    case DepositStatus.PARTIALLY_COMPLETED_CHECK:
      return <Translation {...TXTWCL_Your_transaction_is_being_proc_ELL} />;
    case DepositStatus.REJECTED_MAX_DEPOSITS_LIMIT_EXCEEDED:
      return <Translation {...TXTWCL_Your_deposit_has_been_declined_1} />;
    case DepositStatus.AUTHENTICATION_REQUIRED:
      return <Translation {...TXTCLI_LetXs_get_you_verified} />;
    case DepositStatus.REJECTED_X3D_SECURE2_REQUIRED_ERROR:
      return <Translation {...TXTWCL_Processing_Transaction} />;
    case DepositStatus.REJECTED_PEP_HIO_THIRD_PARTY:
      return <Translation {...TXTWCL_Your_deposit_has_been_declined_1} />;
    case DepositStatus.UNKNOWN_TRANSACTION_ID:
      return <Translation {...TXTWCL_Your_payment_is_taking_a_littl_ELL} />;
    case DepositStatus.COMPLETED:
      return null;
    default:
      return <Translation {...TXTWCL_SorryX_we_canXt_process_your_d_ELL} />;
  }
};
